import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import gamificationStore from '../Stores/GamificationStore';
import userStore from '../Stores/User';
import './BonusIndicator.scss';

const BonusIndicator = observer(({ action, children, className = '', showAlways = false, manualCompletion = false }) => {
  const [showCompletion, setShowCompletion] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  
  const isCompleted = gamificationStore.isActionCompleted(action);
  const isInitialized = gamificationStore.isInitialized;
  const hideChallenges = userStore.hideChallenges;
  
  // Special handling for 500k character bonus - hide if not eligible
  let shouldShow = showAlways || (!isCompleted && isInitialized);
  if (action === gamificationStore.actions.USE_500K_CHARS && !gamificationStore.isEligibleFor500kBonus()) {
    shouldShow = false;
  }

  // Check if action was just completed
  useEffect(() => {
    if (isCompleted && !isAnimating) {
      setIsAnimating(true);
      setShowCompletion(true);
      
      // Hide completion effect after animation
      const timer = setTimeout(() => {
        setShowCompletion(false);
        setIsAnimating(false);
      }, 2000);
      
      return () => clearTimeout(timer);
    }
  }, [isCompleted, isAnimating]);

  const handleManualCompletion = async () => {
    if (!isCompleted) {
      await gamificationStore.completeAction(action);
    }
  };

  if (!shouldShow) {
    return children;
  }

  const bonusAmount = gamificationStore.bonusAmounts[action] || 100000;
  const bonusText = bonusAmount >= 1000000 ? `+${Math.round(bonusAmount / 1000000)}M` : `+${Math.round(bonusAmount / 1000)}k`;

  return (
    <div className={`bonus-indicator ${className} ${isCompleted ? 'completed' : ''}`}>
      {children}
      {/* Only show badge if action is NOT completed AND store is initialized AND challenges are not hidden */}
      {!isCompleted && isInitialized && !hideChallenges && (
        <div className="bonus-badge">
          <span className="bonus-text">{bonusText}</span>
          {manualCompletion && (
            <button 
              className="bonus-checkbox"
              onClick={handleManualCompletion}
              title="Click to claim this bonus after completing the action"
            >
              ✓
            </button>
          )}
        </div>
      )}
      
      {showCompletion && (
        <div className="completion-effect">
          <div className="completion-ring"></div>
        </div>
      )}
    </div>
  );
});

export default BonusIndicator; 